import { useQuery } from '@tanstack/react-query';
import { getContactById } from '../api/contacts';

export function useContact(id: string | null) {
  return useQuery({
    queryKey: ['contact', id],
    queryFn: () => getContactById(id!),
    enabled: id != null && id !== '',
  });
}
